declare global {
    interface Window {
        configProps: any
    }
}

type ConfigSystemProps = {
    IMG_SOURCE: string,
    OTP_LOGIN_VAL: boolean,
    COMPANY_NAME: boolean,
    PRIMARY_COLOR_APP: string,
    FOOTER_INFO: string,
    IMG_LOGIN: string,
    MENUS_PORTAL: number,
    NAME_APP: string,
    DESCRIPTION_APP: string,
}

export const configPortal: ConfigSystemProps = { ...process.env, ...window.configProps }
